<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-plan-pago-universidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'ListadoPlanPagoUniversidad',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          minWidth: 300,
        },
        {
          headerName: 'UNIVERSIDAD',
          field: 'universidad.nombre',
          minWidth: 300,
        },
        {
          headerName: 'PLANES PAGOS CONCEPTOS UNIVERSIDADES',
          autoHeight: true,
          minWidth: 1000,
          maxWidth: 1000,
          filter: false,
          headerComponentParams: {
            template: /* html*/ `
            <table width="100%" style="border-collapse">
              <thead>
                <tr>
                  <th style="font-size: 12px; font-weight: 600; width: 300px; padding-left: 10px; padding-right: 10px;">CONCEPTO</th>
                  <th style="font-size: 12px; font-weight: 600; width: 100px; padding-left: 10px; padding-right: 10px; border-left: 1px solid #cecece;">ORDEN</th>
                  <th style="font-size: 12px; font-weight: 600; width: 100px; padding-left: 10px; padding-right: 10px; border-left: 1px solid #cecece;">N° CUOTAS</th>
                  <th style="font-size: 12px; font-weight: 600; width: 200px; padding-left: 10px; padding-right: 10px; border-left: 1px solid #cecece;">MONTO TOTAL</th>
                  <th style="font-size: 12px; font-weight: 600; width: 100px; padding-left: 10px; padding-right: 10px; border-left: 1px solid #cecece;">PORCENTAJE</th>
                  <th style="font-size: 12px; font-weight: 600; width: 200px; padding-left: 10px; padding-right: 10px; border-left: 1px solid #cecece;">MONTO</th>
                </tr>
              </thead>
            </table>`,
          },
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else {
              let detalle = /* html*/ `

              <table width="100%" style="border-collapse: collapse;">
                <tbody>`;

              params.data.planesPagosConceptosUniversidades.forEach((planPagoConceptoUniversidad) => {
                detalle += /* html*/ `
                <tr class="tr-detalles-ListadoPlanPagoUniversidad" ${
                  !planPagoConceptoUniversidad.estaActivo ? 'style="background-color: #f8d7da; color: #721c24;"' : ''
                }>
                  <td style="font-size: 13px; width: 300px; padding-left: 10px; padding-right: 10px; text-align: left;">${
                    planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre
                  }</td>
                  <td style="font-size: 13px; width: 100px; padding-left: 10px; padding-right: 10px; text-align: right;">${
                    planPagoConceptoUniversidad.orden
                  }</td>
                  <td style="font-size: 13px; width: 100px; padding-left: 10px; padding-right: 10px; text-align: right;">${
                    planPagoConceptoUniversidad.numeroCuotas
                  }</td>
                  <td style="font-size: 13px; width: 200px; padding-left: 10px; padding-right: 10px; text-align: right;">${formatearValorAMoneda(
                    planPagoConceptoUniversidad.montoTotal,
                  )}</td>
                  <td style="font-size: 13px; width: 100px; padding-left: 10px; padding-right: 10px; text-align: right;">${
                    planPagoConceptoUniversidad.porcentaje
                  }</td>
                  <td style="font-size: 13px; width: 200px; padding-left: 10px; padding-right: 10px; text-align: right;">${formatearValorAMoneda(
                    planPagoConceptoUniversidad.monto,
                  )}</td>
                </tr>`;
              });

              detalle += /* html*/ `
                </tbody>
              </table>`;

              return detalle;
            }
          },
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-plan-pago-universidad {
  height: calc(var(--vh, 1vh) * 100 - 24.5rem);
}

.tr-detalles-ListadoPlanPagoUniversidad:not(:last-child) {
  border-bottom: 1px solid #cecece;
}
</style>
  